import Model from "./model";
import SlackIntegration from "./SlackIntegration";
import JiraIntegration from "./JiraIntegration";
import ApiBarrelIntegration from "../api/model/integrations/barrel/Barrelntegration";
import FigmaIntegration from "./FigmaIntegration";

class BarrelIntegration extends Model {
    slacks: SlackIntegration[];
    jira?: JiraIntegration;
    figma?: FigmaIntegration;

    constructor(barrelIntegrationData?: ApiBarrelIntegration) {
        super();

        const { slacks, jira, figma } = barrelIntegrationData ?? {};

        this.slacks = slacks?.map(slack => new SlackIntegration(slack)) ?? [];

        if (jira) {
            this.jira = new JiraIntegration(jira);
        }

        if (figma) {
            this.figma = new FigmaIntegration(figma);
        }
    }
}

export default BarrelIntegration;
